module.exports = __webpack_public_path__ + "assets/img/btn-back-1fc89307.png";